// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37djl","add":"styles_add__tPBhb","remove":"styles_remove__8H0kc"};